import Styles from "css/landing_css/landing_d.module.css";
import Lheader from "components/landing/l_header_d";
import Lfooter from "components/landing/l_footer_d";
import LogoImg from "assets/landing_assets/l_logo_img.png";
import LiosWIcon from "assets/landing_assets/l_ios_w_icon.svg";
import LpsWIcon from "assets/landing_assets/l_ps_w_icon.svg";
import SmartPhoneIcon from "assets/landing_assets/l_smartPhone_icon.svg";
import RepairIcon from "assets/landing_assets/l_repair_icon.svg";
import CheckIcon from "assets/landing_assets/l_check_icon.svg";
import NoteIcon from "assets/landing_assets/l_note_icon.svg";
import ChatIcon from "assets/landing_assets/l_chat_icon.svg";
import PersonIcon from "assets/landing_assets/l_person_icon.svg";
import ScreenShot1 from "assets/landing_assets/l_screenShot_img.png";
import ScreenShot2 from "assets/landing_assets/l_screenShot2_img.png";
import ScreenShot3 from "assets/landing_assets/l_screenShot3_img.png";
import ScreenShot4 from "assets/landing_assets/l_screenShot4_img.png";
import LiosGIcon from "assets/landing_assets/l_ios_g_icon.svg";
import LpsGIcon from "assets/landing_assets/l_ps_g_icon.svg";
import { Link } from "react-router-dom";

const APP_STORE_URL =
  "https://apps.apple.com/kr/app/%EB%9A%9D%EB%94%B1%EC%9D%B4-%EA%B0%84%ED%8E%B8%ED%95%9C-%EC%88%98%EB%A6%AC%EA%B8%B0%EC%82%AC-%EB%A7%A4%EC%B9%AD/id6743381425";
const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.ttugttag.ttug&pcampaignid=web_share";

function LandingMainScreen() {
  return (
    <div>
      <Lheader />

      {/* Hero */}
      <section className={Styles.firstContainer} style={{ padding: "96px max(32px, 5vw)" }}>
        <div className={Styles.firstContent}>
          <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <span
                style={{
                  display: "inline-flex",
                  alignSelf: "flex-start",
                  padding: "6px 14px",
                  borderRadius: 9999,
                  backgroundColor: "#D1FAE5",
                  color: "#047857",
                  fontSize: 13,
                  fontWeight: 700,
                  letterSpacing: "0.01em",
                }}
              >
                농민과 기술자를 잇다
              </span>
              <h1 className={Styles.f48w700black}>
                복잡한 수리 요청
                <br />
                뚝딱이로 한 번에!
              </h1>
            </div>
            <p className={Styles.f20w400grey}>
              농기계 고장, 더 이상 헤매지 마세요.
              <br />
              뚝딱이는 농가와 수리기사를 실시간으로 연결해주는 매칭 플랫폼입니다.
            </p>
            <div style={{ display: "flex", gap: 12, marginTop: 8 }}>
              <Link to={APP_STORE_URL} className={Styles.appleButton} target="_blank">
                <img src={LiosWIcon} alt="" style={{ width: 18, height: 22 }} />
                <span className={Styles.f16w400white}>App Store</span>
              </Link>
              <Link to={PLAY_STORE_URL} className={Styles.appleButton} target="_blank">
                <img src={LpsWIcon} alt="" style={{ width: 22, height: 24 }} />
                <span className={Styles.f16w400white}>Play Store</span>
              </Link>
            </div>
          </div>
          <img src={LogoImg} alt="뚝딱이 캐릭터" />
        </div>
      </section>

      {/* 이용 방법 */}
      <section className={Styles.secondContainer}>
        <h2 className={Styles.f36w700black}>이용 방법</h2>
        <div style={{ height: 12 }} />
        <p className={Styles.f16w400grey} style={{ textAlign: "center" }}>
          간단한 3단계로 빠르게 수리 기사를 연결받으세요
        </p>
        <div style={{ height: 56 }} />
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: 40,
            width: "100%",
            maxWidth: 1100,
          }}
        >
          {[
            { icon: SmartPhoneIcon, title: "1. 수리 요청 등록", desc: "농기계 고장 내용을 사진과 함께 앱에 등록하세요" },
            { icon: RepairIcon, title: "2. 수리기사 매칭", desc: "주변의 수리기사에게 실시간으로 요청이 전달됩니다" },
            { icon: CheckIcon, title: "3. 현장 수리 진행", desc: "매칭된 수리기사가 농가에 방문하여 장비를 수리합니다" },
          ].map((step) => (
            <div key={step.title} style={{ textAlign: "center" }}>
              <div className={Styles.greenBall}>
                <img src={step.icon} alt="" />
              </div>
              <div style={{ height: 24 }} />
              <h3 className={Styles.f20w700black}>{step.title}</h3>
              <div style={{ height: 12 }} />
              <p className={Styles.f16w400grey}>{step.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* 주요 기능 */}
      <section className={Styles.thirdContainer}>
        <h2 className={Styles.f36w700black}>주요 기능</h2>
        <div style={{ height: 56 }} />
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
            gap: 28,
            width: "100%",
            maxWidth: 1100,
          }}
        >
          {[
            { icon: NoteIcon, title: "수리 요청 시스템", desc: "사진과 고장 내용을 쉽게 등록할 수 있는 간편한 수리 요청 기능을 제공합니다" },
            { icon: ChatIcon, title: "커뮤니티", desc: "농가 사용자들과 수리기사들이 자유롭게 소통하고 정보를 공유할 수 있는 커뮤니티 기능을 제공합니다" },
            { icon: PersonIcon, title: "실시간 기사 매칭", desc: "요청 등록과 동시에 가까운 수리기사에게 알림이 전송되어 빠른 매칭이 가능합니다" },
          ].map((feat) => (
            <div key={feat.title} className={Styles.thirdContent}>
              <img src={feat.icon} alt="" style={{ width: 48, height: 48 }} />
              <div style={{ height: 20 }} />
              <h3 className={Styles.f20w700black}>{feat.title}</h3>
              <div style={{ height: 12 }} />
              <p className={Styles.f16w400grey}>{feat.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* 앱 스크린샷 */}
      <section className={Styles.fourthContainer}>
        <h2 className={Styles.f36w700black}>앱 스크린샷</h2>
        <div style={{ height: 48 }} />
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
            gap: 40,
            width: "100%",
            maxWidth: 1100,
          }}
        >
          {[ScreenShot1, ScreenShot2, ScreenShot3, ScreenShot4].map((src, i) => (
            <img key={i} src={src} alt={`앱 스크린샷 ${i + 1}`} style={{ width: "100%", borderRadius: 16 }} />
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className={Styles.fifthContainer}>
        <h2 className={Styles.f36w700white}>지금 바로 시작해보세요!</h2>
        <div style={{ height: 16 }} />
        <p className={Styles.f20w400white} style={{ maxWidth: 640 }}>
          뚝딱이 앱을 다운로드하고 빠르고 신뢰할 수 있는 수리 서비스를 경험해보세요
        </p>
        <div style={{ height: 36 }} />
        <div style={{ display: "flex", gap: 16, flexWrap: "wrap", justifyContent: "center" }}>
          <Link to={APP_STORE_URL} className={Styles.appleButtonWhite} target="_blank">
            <img src={LiosGIcon} alt="" style={{ width: 18, height: 22 }} />
            <span className={Styles.f16w400green}>App Store에서 다운로드</span>
          </Link>
          <Link to={PLAY_STORE_URL} className={Styles.appleButtonWhite} target="_blank">
            <img src={LpsGIcon} alt="" style={{ width: 22, height: 24 }} />
            <span className={Styles.f16w400green}>플레이스토어 다운로드</span>
          </Link>
        </div>
      </section>

      <Lfooter />
    </div>
  );
}

export default LandingMainScreen;
